/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Ikhextern9Inputs */

const en__field_enum_ikhextern9 = /** @type {(inputs: _Field_Enum_Ikhextern9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extern`)
};

const de__field_enum_ikhextern9 = /** @type {(inputs: _Field_Enum_Ikhextern9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extern`)
};

/**
* | output |
* | --- |
* | "Extern" |
*
* @param {_Field_Enum_Ikhextern9Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_ikhextern9 = /** @type {((inputs?: _Field_Enum_Ikhextern9Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Ikhextern9Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_ikhextern9(inputs)
	return de__field_enum_ikhextern9(inputs)
});
export { _field_enum_ikhextern9 as "_field_enum_IKHEXTERN" }